import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { completeInfusion } from "../../../slices/logisticSlice";
import FormikControl from "../FormikControl";
import { selectCurrentCycle } from "../../../slices/common";
import moment from 'moment';
import { useState } from "react";

const CompleteInfusionForm = (
  formProps
) => {
  const dispatch = useDispatch();
  const currentCycle = useSelector(selectCurrentCycle);
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    completed_date: Yup.string().required("Please select completion date")
  });

  const infusionStep = currentCycle?.data?.find((it) => it?.slug == 'infusion');
  const is_cr = infusionStep?.change_requests?.length > 0 ? true : false;

  const initialCompletedDate = (currentCycle?.complete_date && currentCycle.complete_date !== 'null')
    ? moment(currentCycle.complete_date, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601]).format("DD/MM/YYYY")
    : (infusionStep?.completed_date && infusionStep.completed_date !== 'null')
      ? moment(infusionStep.completed_date, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601]).format("DD/MM/YYYY")
      : "";

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const id = formProps?.product_logistic_id || currentCycle?.shipment_logistic_id;
      const formattedDate = moment(values?.completed_date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss");
      
      const payload = {
        id: id,
        data: {
          complete_date: formattedDate,
          product_manufacturing_id: currentCycle?.product_manufacturing_id,
          is_cr: is_cr
        }
      };
      
      const res = await dispatch(completeInfusion(payload)).unwrap();
      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error completing infusion:", err);
    } finally {
      setIsLoading(false); 
    }
  };

  const formik = useFormik({
    initialValues: {
      completed_date: initialCompletedDate,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
    {
      label: 'Completion Date',
      type: 'date',
      name: 'completed_date',
      placeholder: 'Enter Date',
      required: true,
    }
  ];

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              loading={isLoading}
              disabled={isLoading}  
              sx={{ backgroundColor: "#3571FF", '&.Mui-disabled': {
                  pointerEvents: 'auto',     
                  cursor: 'not-allowed',       
                } }}
            >
              Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CompleteInfusionForm;
